<template>
    <div>
        <template v-if="loading">
            <loading-spinner />
        </template>

        <template v-else>
            <x-container app-width fluid>
                <x-layout align-end mb-5>
                    <x-flex>
                        <h1>Client & entity management</h1>
                    </x-flex>
                </x-layout>

                <x-layout>
                    <x-flex>
                        <x-container fluid class="summary-container">
                            <x-layout class="mt-3">
                                <x-flex xs6 class="left">
                                    <client-manager
                                        :clients="clients"
                                        v-model="selectedClientId"
                                        @clientUpdated="loadClients"
                                    />
                                </x-flex>

                                <x-flex xs6 class="right">
                                    <entity-manager
                                        :client="selectedClient"
                                    />
                                </x-flex>
                            </x-layout>
                        </x-container>
                    </x-flex>
                </x-layout>
            </x-container>
        </template>
    </div>
</template>

<script>
import ClientManager from "./ClientManager.vue";
import EntityManager from "./EntityManager.vue";

export default {
    name: "ClientAndEntityManager",
    components: {
        EntityManager,
        ClientManager
    },
    data() {
        return {
            loading: false,
            clients: [],
            selectedClientId: null,
            selectedClient: null
        };
    },
    async mounted() {
        this.loadClients();
    },
    watch: {
        selectedClientId() {
            this.selectedClient = this.clients.find(client => client.id == this.selectedClientId);
        }
    },
    methods: {
        async loadClients() {
            this.clients = (await axios.get(this.$root.api(`client`))).data.data;
        }
    }
}
</script>

<style scoped lang="scss">
    .component-container {
        display: flex;
        flex: 0 0 0;
        flex-basis: 33%;
        align-content: flex-start;
        flex-wrap: wrap;
    }
    .entity-manager-component-container {
        @extend .component-container;
        flex-basis: 62%;
    }
</style>
